import template from './sw-search-bar-item.html.twig';

export default {
    template
};